import { render } from "./OrdersComponent.vue?vue&type=template&id=6e86947a&scoped=true"
import script from "./OrdersComponent.vue?vue&type=script&lang=js"
export * from "./OrdersComponent.vue?vue&type=script&lang=js"

import "./OrdersComponent.vue?vue&type=style&index=0&id=6e86947a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e86947a"]])

export default __exports__